"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultFlagNamesMap = exports.flagColor = exports.Flag = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
// eslint-disable-next-line no-shadow
var Flag;
(function (Flag) {
    Flag["GREEN"] = "green";
    Flag["ORANGE"] = "orange";
    Flag["RED"] = "red";
    Flag["BLACK"] = "black";
    Flag["PURPLE"] = "purple";
    Flag["BLUE"] = "blue";
})(Flag = exports.Flag || (exports.Flag = {}));
exports.default = Flag;
const flagColor = flag => {
    switch (flag) {
        case Flag.GREEN:
            return lib_palette_1.default.Greeny;
        case Flag.ORANGE:
            return lib_palette_1.default.OJ;
        case Flag.RED:
            return lib_palette_1.default.CoralRed;
        case Flag.BLACK:
            return lib_palette_1.default.BlackCoral;
        case Flag.PURPLE:
            return lib_palette_1.default.LibertyPurple;
        case Flag.BLUE:
            return lib_palette_1.default.GoodOldBlue;
        default:
            return lib_palette_1.default.Liquorice;
    }
};
exports.flagColor = flagColor;
exports.DefaultFlagNamesMap = {
    [Flag.GREEN]: 'Green',
    [Flag.ORANGE]: 'Orange',
    [Flag.RED]: 'Red',
    [Flag.BLACK]: 'Black',
    [Flag.PURPLE]: 'Purple',
    [Flag.BLUE]: 'Blue',
};
